import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  optionsData: [],
  newOption: {},
  display: {},
  message: null,
};

export const getAttributes = createAsyncThunk(
  "getAttributes",
  async (data) => {
    try {
      const response = await fetch(`/api/getAttributes/${data.configId}/${data.locale}`, {
        method: "GET",
        cache: "no-store",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch attributes");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const credentialsSlice = createSlice({
  name: "getAttributes",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAttributes.pending, (state) => {
        state.status = "PIM loading";
        state.message = null;
      })
      .addCase(getAttributes.fulfilled, (state, action) => {
        state.status = "PIM loaded";
        state.optionsData = [];  // Clear the existing data

        // Transform the payload data
        const transformedData = [];
        const response = action.payload.data.data;

        for (const key in response) {
          if (response.hasOwnProperty(key)) {
            const transformedObject = { [key]: [] };

            response[key].forEach((item) => {
              const newItem = {
                code: item.code,
                // label: {
                //   en_US: item.labels.en_US,
                // },
                displayName: item.displayName,
                type: item.type,
              };

              transformedObject[key].push(newItem);
            });

            transformedData.push(transformedObject);
          }
        }

        state.optionsData = transformedData;
        transformedData.forEach((item) => {
          Object.keys(item).forEach((key) => {
            item[key].forEach((subItem) => {
              state.newOption[subItem.code] = subItem.type;
              state.display[subItem.code] = subItem.displayName;
            });
          });
        })
      })
      .addCase(getAttributes.rejected, (state, action) => {
        state.status = "error";
        state.message = action.error.message;
      });
  },
});

export default credentialsSlice.reducer;
